async function fetchCustomer(userUUID: string) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}chat/get-customer-chat-list?userUuid=${userUUID}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return await response.json();
  } catch (e) {
    console.error(e);
  }
}

async function getChatHistory(conversationUuid: string, customerUuid: string, userUuid: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}chat/get-user-chat-history?conversationUuid=${conversationUuid}&customerUuid=${customerUuid}&userUuid=${userUuid}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return await response.json();
}

async function closeConversation(chatInfo: { conversationUuid: string }) {
  const response = await fetch(process.env.REACT_APP_API_URL + `chat/close-chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(chatInfo)
  });
  return response;
}

export { fetchCustomer, getChatHistory, closeConversation };
